import React, { useEffect, useState, useCallback } from "react";
import {
  Container,
  Row,
  Card,
  CardBody,
  CardHeader,
  Col,
  Spinner,
  Input,
  InputGroup,
  Button,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AwesomePagination from "../../../Components/Common/AwesomePagination";
import ModalMigrar from "./ModalMigrar";
import { APIClient } from "../../../helpers/api_helper";
import { toast } from "react-toastify";
import FeatherIcon from "feather-icons-react";

const apiClient = new APIClient();

const TabelaClientes = () => {
  const [loading, setLoading] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(true);
  const [termo, setTermo] = useState("");
  const [inputTermo, setInputTermo] = useState("");
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [totalItens, setTotalItens] = useState(0);
  const [clientes, setClientes] = useState([]);
  const [clienteId, setClienteId] = useState(null);
  const [modalMigrar, setmodalMigrar] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  // Estados para modais de confirmação
  const [modalReset2FA, setModalReset2FA] = useState(false);
  const [modalMigrarHistorico, setModalMigrarHistorico] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);

  const getClientes = useCallback(async () => {
    setLoading(true);
    let data = {
      pagina: pagina,
      itens_pagina: 20,
      order_by: "created_at",
      order: "desc",
    };

    if (termo && termo !== "") {
      data.termo = termo;
    }

    const response = await apiClient.post("/client/clientes/busca", data);

    if (response.sucesso) {
      setClientes(response.dados.data);
      setTotalPaginas(response.dados.last_page);
      setTotalItens(response.dados.total);
    } else {
      toast.error(response.mensagem);
    }
    setLoading(false);
  }, [pagina, termo]);

  const desativar2fa = async (userId) => {
    const response = await apiClient.delete(`/secrets2fa/${userId}`);
    
    if (response.sucesso) {
      toast.success(response.mensagem);
    } else {
      toast.error(response.mensagem);
    }
    setModalReset2FA(false);
    setClienteSelecionado(null);
  };

  const migrarHistorico = useCallback(
    async (userId) => {
      setLoadingButton(true);
      const response = await apiClient.post(`/migrate-historico/${userId}`);
      
      if (response.sucesso) {
        toast.success(response.mensagem);
        setShouldFetch(true);
      } else {
        toast.error(response.mensagem);
      }
      setLoadingButton(false);
      setModalMigrarHistorico(false);
      setClienteSelecionado(null);
    },
    []
  );

  function formatName(name) {
    if (!name) return "";
    let lowerCaseName = name.toLowerCase();
    let properName = lowerCaseName.replace(
      /(^|\s|')(\w)/g,
      function (match, separator, letter, index, fullText) {
        // Encontra a palavra completa a partir do índice
        const matchResult = fullText.slice(index).match(/^[^\s']+|\b\w+/);
        // Se matchResult for null, retorna a letra original
        if (!matchResult) {
          return match;
        }
        const word = matchResult[0];
        const lowerCaseWords = ["de", "da", "do", "dos", "das"];
        if (lowerCaseWords.includes(word)) {
          return separator + letter;
        }
        return separator + letter.toUpperCase();
      }
    );

    return properName;
  }

  const formatCurrency = (value) => {
    if (!value) {
      return "R$ 0,00";
    }
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value);
  };

  // Handlers para abrir modais de confirmação
  const handleReset2FA = (cliente) => {
    setClienteSelecionado(cliente);
    setModalReset2FA(true);
  };

  const handleMigrarHistorico = (cliente) => {
    setClienteSelecionado(cliente);
    setModalMigrarHistorico(true);
  };

  const handleMigrarSaldos = (cliente) => {
    setClienteId(cliente.user_id);
    setmodalMigrar(true);
  };

  useEffect(() => {
    if (shouldFetch) {
      const fetchData = async () => {
        await getClientes();
        setShouldFetch(false);
      };
      fetchData();
    }
  }, [shouldFetch, getClientes]);

  document.title = "Clientes | Painel Fort Exchange";

  const handleTermoKeyDown = (e) => {
    if (e.key === "Enter") {
      setTermo(inputTermo);
      setPagina(1);
      setShouldFetch(true);
    }
  };

  return (
    <React.Fragment>
      <ModalMigrar
        cliente_id={clienteId}
        setmodalMigrar={setmodalMigrar}
        modalMigrar={modalMigrar}
        setShouldFetch={setShouldFetch}
      />

      {/* Modal de Confirmação Reset 2FA */}
      <Modal isOpen={modalReset2FA} toggle={() => setModalReset2FA(false)}>
        <ModalHeader toggle={() => setModalReset2FA(false)}>
          Confirmar Reset 2FA
        </ModalHeader>
        <ModalBody>
          <p>
            Tem certeza que deseja resetar o 2FA do cliente{" "}
            <strong>{clienteSelecionado?.nome_completo}</strong>?
          </p>
          <p className="text-muted">
            Esta ação irá remover a configuração de autenticação de dois fatores
            do cliente.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalReset2FA(false)}>
            Cancelar
          </Button>
          <Button
            color="info"
            onClick={() => desativar2fa(clienteSelecionado?.user_id)}
          >
            Confirmar Reset
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal de Confirmação Migrar Histórico */}
      <Modal isOpen={modalMigrarHistorico} toggle={() => setModalMigrarHistorico(false)}>
        <ModalHeader toggle={() => setModalMigrarHistorico(false)}>
          Confirmar Migração de Histórico
        </ModalHeader>
        <ModalBody>
          <p>
            Tem certeza que deseja migrar o histórico do cliente{" "}
            <strong>{clienteSelecionado?.nome_completo}</strong>?
          </p>
          <p className="text-muted">
            Esta ação irá processar e migrar todo o histórico de transações do
            cliente.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalMigrarHistorico(false)}>
            Cancelar
          </Button>
          <Button
            color="danger"
            onClick={() => migrarHistorico(clienteSelecionado?.user_id)}
            disabled={loadingButton}
          >
            {loadingButton ? "Migrando..." : "Confirmar Migração"}
          </Button>
        </ModalFooter>
      </Modal>

      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Clientes" pageTitle="Aplicações" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader className="d-flex align-items-center border-0">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Clientes FORT ({totalItens})
                  </h5>
                  <div className="flex-shrink-0">
                    <div className="flax-shrink-0 hstack gap-2">
                      <Link to="/clientes-cadastro" className="btn btn-primary">
                        Cadastrar Cliente
                      </Link>
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  {/* Filtros */}
                  <Row className="mb-3">
                    <Col md={12}>
                      <InputGroup>
                        <div className="input-group-text">
                          <FeatherIcon icon="search" className="icon-dual" />
                        </div>
                        <Input
                          type="text"
                          placeholder="Buscar por nome, email ou CPF/CNPJ..."
                          value={inputTermo}
                          onChange={(e) => setInputTermo(e.target.value)}
                          onKeyDown={handleTermoKeyDown}
                        />
                      </InputGroup>
                    </Col>
                  </Row>

                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        padding: "20px",
                      }}
                    >
                      <Spinner height={100} width={100} />
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>Cliente</th>
                              <th>E-mail</th>
                              <th>CPF</th>
                              <th>Saldo Total</th>
                              <th>Limite Mensal</th>
                              <th>Ações</th>
                            </tr>
                          </thead>
                          <tbody>
                            {clientes.length === 0 ? (
                              <tr>
                                <td
                                  colSpan={6}
                                  className="text-center text-muted py-4"
                                >
                                  Nenhum cliente encontrado.
                                </td>
                              </tr>
                            ) : (
                              clientes.map((item, idx) => (
                                <tr key={item.id || idx}>
                                  {/* Cliente */}
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="flex-grow-1 ms-2">
                                        <b style={{ color: "darkBlue" }}>
                                          {item.nome_completo ? formatName(item.nome_completo) : ""}
                                        </b>
                                        <br />
                                        {item.metamap_status_verification && (
                                          <Badge
                                            color={
                                              item.metamap_status_verification === "verified"
                                                ? "success"
                                                : "danger"
                                            }
                                            className="me-1"
                                          >
                                            {item.metamap_status_verification}
                                          </Badge>
                                        )}
                                      </div>
                                    </div>
                                  </td>

                                  {/* E-mail */}
                                  <td>
                                    <span style={{ color: "darkGreen" }}>
                                      {item.email}
                                    </span>
                                  </td>

                                  {/* CPF */}
                                  <td>{item.cpf_cnpj}</td>

                                  {/* Saldo Total */}
                                  <td>
                                    {formatCurrency(
                                      parseFloat(item.saldo_brl ?? 0) +
                                        parseFloat(item.saldo_subcontas ?? 0)
                                    )}
                                  </td>

                                  {/* Limite Mensal */}
                                  <td>
                                    {formatCurrency(item.negociar_mensalmente)}
                                  </td>

                                  {/* Ações */}
                                  <td>
                                    <div className="d-flex gap-1">
                                      {/* Ver Dados */}
                                      <Link to={`/clientes/${item.user_id}`}>
                                        <Button
                                          color="primary"
                                          size="sm"
                                          className="btn-icon"
                                          title="Ver Dados do Cliente"
                                        >
                                          <FeatherIcon icon="user" size={14} />
                                        </Button>
                                      </Link>

                                      {/* Resetar 2FA */}
                                      <Button
                                        color="info"
                                        size="sm"
                                        className="btn-icon"
                                        title="Resetar 2FA"
                                        onClick={() => handleReset2FA(item)}
                                      >
                                        <FeatherIcon icon="shield-off" size={14} />
                                      </Button>

                                      {/* Ver Logs */}
                                      <Link to={`/logs/${item.user_id}`}>
                                        <Button
                                          color="secondary"
                                          size="sm"
                                          className="btn-icon"
                                          title="Ver Logs do Cliente"
                                        >
                                          <FeatherIcon icon="file-text" size={14} />
                                        </Button>
                                      </Link>

                                      {/* Migrar Saldos */}
                                      {!item.saldo_migrado && (
                                        <Button
                                          color="warning"
                                          size="sm"
                                          className="btn-icon"
                                          title="Migrar Saldos"
                                          onClick={() => handleMigrarSaldos(item)}
                                          disabled={loadingButton}
                                        >
                                          <FeatherIcon icon="dollar-sign" size={14} />
                                        </Button>
                                      )}

                                      {/* Migrar Histórico */}
                                      {!item.historico_migrado && (
                                        <Button
                                          color="danger"
                                          size="sm"
                                          className="btn-icon"
                                          title="Migrar Histórico"
                                          onClick={() => handleMigrarHistorico(item)}
                                          disabled={loadingButton}
                                        >
                                          <FeatherIcon icon="archive" size={14} />
                                        </Button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                      <AwesomePagination
                        pagina={pagina}
                        totalPaginas={totalPaginas}
                        setPagina={(p) => {
                          setPagina(p);
                          setShouldFetch(true);
                        }}
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TabelaClientes;
